<template>
<div class="social">
    <ul>
        <li><a href="https://www.yelp.com/biz/a-list-makeup-milpitas-4?q=tam" target="_blank" class="fab fa-yelp"></a></li>
        <li><a href="https://www.facebook.com/dan.t.truong.7" target="_blank" class="fab fa-facebook-f"></a></li>
        <li><a href="https://www.instagram.com/dantambeauty/" target="_blank" class="fab fa-instagram"></a></li>
        <li><a href="#" target="_blank" class="fab fa-pinterest"></a></li>
    </ul>
</div>
</template>

<script>
export default {
    name: 'Social',
}
</script>